
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...mtgAgentDetailsFR]",
      function () {
        return require("private-next-pages/[...mtgAgentDetailsFR].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...mtgAgentDetailsFR]"])
      });
    }
  